import * as React from 'react';
import { classes, style } from 'typestyle';
import { White } from '../../../styles/colors';
const WindowBody = ({ children, className }) => {
    return React.createElement("div", { className: classes('tds-window-body', windowBodyStyle, className) }, children);
};
export default WindowBody;
const windowBodyStyle = style({
    flexGrow: 1,
    background: White,
    overflowY: 'auto',
});
//# sourceMappingURL=WindowBody.js.map